React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
View = require 'app/scripts/views/internal/view'
{ renderComponent } = require 'app/src/components/ComponentWrapper'

module.exports = class DomainFreeTeamLimitWarningBanner extends View
  initialize: ->
    @loadBannerPromise ?= `import(/* webpackChunkName:"free-team-limit-banners"*/'app/src/components/FreeTeamLimitBanners')`
      .then((module) =>
        @WarningBanner = module.WarningBanner
        @render()
      )

  render: ->
    if (!@WarningBanner)
      return @

    banner = React.createElement(@WarningBanner, {
      memberId: @model.get('id'),
      onDismiss: =>
        @remove()
    })
    renderComponent(banner, @el)
    @

  remove: ->
    ReactDOM.unmountComponentAtNode(@el)
    super
